import { render, staticRenderFns } from "./Audience.vue?vue&type=template&id=67213b7c&scoped=true"
import script from "./Audience.vue?vue&type=script&lang=js"
export * from "./Audience.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67213b7c",
  null
  
)

export default component.exports